import script from "./SettingLanguageComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingLanguageComponent.vue?vue&type=script&setup=true&lang=js"

import "./SettingLanguageComponent.vue?vue&type=style&index=0&id=c18b3532&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c18b3532"]])

export default __exports__